// extracted by mini-css-extract-plugin
export var actionButton = "_dc-0";
export var attachmentLine = "_dc-1";
export var fileInput = "_dc-2";
export var fileUploadWrapper = "_dc-4";
export var footer = "_dc-3";
export var modalContent = "_dc-5";
export var paperclip = "_dc-6";
export var quillEditor = "_dc-7";